import { NOTIFY } from '@app/actions/notifications';

const initialState = {
  current: {},
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFY:
      return {
        ...state,
        current: {
          id: action.id,
          message: action.message,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default notifications;



// WEBPACK FOOTER //
// ./src/reducer/notifications.js